enum PREFERENCES {
  MCSC = 'show_mcsc_splash_page'
}

export default PREFERENCES;
